import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'

export const PF_RECEIVED_PERSONALINFOS = 'PF_RECEIVED_PERSONALINFOS'
export const PF_GETTING_PERSONALINFOS = 'PF_GETTING_PERSONALINFOS'
export const PF_GETTING_PERSONALINFOS_ERROR = 'PF_GETTING_PERSONALINFOS_ERROR'
export const PF_SET_SELECTEDFILTERSTATUS = 'PF_SET_SELECTEDFILTERSTATUS'
export const PF_SET_SELECTEDFILTERCODE = 'PF_SET_SELECTEDFILTERCODE'
export const PF_SET_SELECTEDFILTERLOCATION = 'PF_SET_SELECTEDFILTERLOCATION'
export const PF_SET_SELECTEDPARTNER = 'PF_SET_SELECTEDPARTNER'

const fetching = () => ({
  type: PF_GETTING_PERSONALINFOS,
})

const fetchingerror = () => ({
  type: PF_GETTING_PERSONALINFOS_ERROR,
})

const receive = personalinfos => ({
  type: PF_RECEIVED_PERSONALINFOS,
  personalinfos,
})

const selectedfilter = (selectedFilter, selectedFilterType) => ({
  type: selectedFilterType,
  selectedFilter,
})

const selectedPartner = selectedPartnerInfo => ({
  type: PF_SET_SELECTEDPARTNER,
  selectedPartnerInfo,
})

export function setStatusFilter(selectedStatusFilter) {
  return (dispatch) => {
    dispatch(selectedfilter(selectedStatusFilter, PF_SET_SELECTEDFILTERSTATUS))
  }
}

export function setCodeFilter(selectedCodeFilter) {
  return (dispatch) => {
    dispatch(selectedfilter(selectedCodeFilter, PF_SET_SELECTEDFILTERCODE))
  }
}

export function setLocationFilter(selectedLocationFilter) {
  return (dispatch) => {
    dispatch(selectedfilter(selectedLocationFilter, PF_SET_SELECTEDFILTERLOCATION))
  }
}

export function setSelectedPartner(selectedPartnerInfo) {
  return (dispatch) => {
    sessionStorage.setItem('SelectedPartner', JSON.stringify(selectedPartnerInfo))
    dispatch(selectedPartner(selectedPartnerInfo))
  }
}

export function getPersonalInfos(employeeId) {
  return (dispatch, getState) => {
    dispatch(fetching())
    agent.PersonalInfo.list(getState().personalinfos.selectedStatusFilter, employeeId).then((response) => {
      const personalinfo = response.map(partner => ({
        id: partner.EmployeeID,
        initials: `${partner.EmployeeFirstName.charAt(0)}${partner.EmployeeSurname.charAt(0)}`,
        name: partner.EmployeeName,
        status: `${partner.Status === true ? 'Active' : 'Inactive'}`,
        code: partner.Code,
        location: partner.Location,
        email: partner.Email,
        Counselling_Partner_Name: partner.Counselling_Partner_Name,
        Business_Leader_Name: partner.Business_Leader_Name,
        Market_Leader_Name: partner.Market_Leader_Name,
        Client_Industry_Leader_Name: partner.Client_Industry_Leader_Name,
        Service_Area_Leader_Name: partner.Service_Area_Leader_Name,
        Counselling_Partner_Employee_Id: partner.Counselling_Partner_Employee_Id,
        Business_Leader_Employee_Id: partner.Business_Leader_Employee_Id,
        Market_Leader_Employee_Id: partner.Market_Leader_Employee_Id,
        Client_Industry_Leader_Employee_Id: partner.Client_Industry_Leader_Employee_Id,
        Service_Area_Leader_Employee_Id: partner.Service_Area_Leader_Employee_Id,
      }))
      dispatch(receive(personalinfo))
      // dispatch(notify('Successfully load admin centre'))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <getPersonalInfos>: ', description, error)
        dispatch(fetchingerror())
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/personalInfos.js